import React, { useContext, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import AppContext from "../../hooks/appContext";
import {calcCartTotal, calcCartTax, calcCartDiscount, formatMoney} from "../../utils/helpers";
import doToast from "../doToast/doToast";

const CartFooter = (props) => {
  const {
    cart,
    cartPage,
    changeCartPage,
    currentCurrency,
    activeAttributes,
    paymentError,
    deliveryFee,
    shippingFormValues,
    setShippingFormValues,
    validateShippingForm,
    onlyDigitalProducts,
    getStoreTax,
    coupon,
    setCoupon,
    discountAmt,
    setDiscountAmt,
  } = useContext(AppContext);

  const [formError, setFormError] = useState("");

  let cartTax = getStoreTax();

  const taxAmount = (calcCartTax(cart, cartTax, deliveryFee, coupon?.value, coupon?.type, currentCurrency, activeAttributes));

  const handleChangeCartPage = () => {
    if (cart.length > 0) {
      if (cartPage === "cart") {
        changeCartPage("shipping")
      } else if (cartPage === "shipping") {
        let validation = validateShippingForm();
        
        if (validation?.error) {
          // setFormError(validation.message);
          // setTimeout(() => {
          //   setFormError("");
          // }, 2500);
          doToast(validation.message, "error");
          return;
        }

        if (shippingFormValues?.deliveryMethod === 'delivery' && !shippingFormValues.deliveryLocation) {
          doToast("Please select a delivery location", "error");
          return;
        }

        if (shippingFormValues?.deliveryMethod === 'pickup' && !shippingFormValues.pickupLocation) {
          doToast("Please select a pickup location", "error");
          return;
        }

        let isOnlyDigital = onlyDigitalProducts();
        if (!isOnlyDigital && (typeof shippingFormValues?.deliveryMethod !== 'string' || !shippingFormValues?.deliveryMethod)) {
          // setFormError("Please select a delivery method");
          // setTimeout(() => {
          //   setFormError("");
          // }, 2500);
          doToast("Please select a delivery method", "error");
          return;
        }
        
        let amountToPay = formatMoney((calcCartTotal(cart, currentCurrency, activeAttributes) + parseInt(deliveryFee) + parseInt(taxAmount) - discountAmt) / 100);
        if (amountToPay <= 0) {
          doToast("Total amount must be greater than 0", "error");
          return;
        }
        
        changeCartPage("order")
      } else if (cartPage === "order") {
        props.createOrder(shippingFormValues);
      }
    }
  }

  useEffect(() => {
    if (coupon) {
      let discountAmount = calcCartDiscount(cart, deliveryFee, coupon?.value, coupon?.type, currentCurrency, activeAttributes);
      setDiscountAmt(discountAmount);
    } else {
      setDiscountAmt(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coupon]);

  useEffect(() => {
    if (cartPage === "cart") {
      setCoupon();
      setDiscountAmt(0);
      setShippingFormValues({ ...shippingFormValues, couponCode: "" })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartPage]);

  const discountClasses = `${styles['fee-value']} ${styles.discount}`;
  const checkoutButtonClasses = `${styles.btn} ${styles['btn-checkout']}`;

  return (
    <>
      <div className={styles['cart-summary']}>
        {
          formError !== "" &&
          <div className={styles['form-error']}>
            {formError}
          </div>
        }
        {
          paymentError !== "" &&
          <div className={styles['form-error']}>
            {paymentError}
          </div>
        }
        
        {
          cartPage !== "order" &&
          <div className={styles['summary-top']}>
            <div className={styles['cart-count']}>{cart.length} {cart.length !== 1 ? 'items' : 'item'}</div>
              <div className={styles['cart-total']}>
                {currentCurrency === 'NGN' ?
                  <span dangerouslySetInnerHTML={{ __html: "&#8358;" }}></span>
                  : '$'
                } {formatMoney(calcCartTotal(cart, currentCurrency, activeAttributes) / 100)}
              </div>
          </div>
        }
        
        {
          cartPage === "shipping" && shippingFormValues?.deliveryMethod === 'delivery' &&
          <div className={styles['delivery-fee']}>
            <div className={styles['fee-title']}>Delivery fee</div>
              <div className={styles['fee-value']}>
                {currentCurrency === 'NGN' ?
                  <span dangerouslySetInnerHTML={{ __html: "&#8358;" }}></span>
                  : '$'
                } {formatMoney(deliveryFee / 100)}
              </div>
          </div>
        }

        {
          cartTax && cartPage === "shipping" &&
          <div className={styles['delivery-fee']}>
            <div className={styles['fee-title']}>Vat</div>
              <div className={styles['fee-value']}>
                {currentCurrency === 'NGN' ?
                  <span dangerouslySetInnerHTML={{ __html: "&#8358;" }}></span>
                  : '$'
                } {formatMoney((calcCartTax(cart, cartTax, deliveryFee, coupon?.value, coupon?.type, currentCurrency, activeAttributes)) / 100)}
              </div>
          </div>
        }

        {
          discountAmt > 0 && cartPage === "shipping" &&
          <div className={styles['delivery-fee']}>
            <div className={styles['fee-title']}>Discount</div>
              <div className={discountClasses}>-{
                currentCurrency === 'NGN' ?
                  <span dangerouslySetInnerHTML={{ __html: "&#8358;" }}></span>
                  : '$'
                } {formatMoney(discountAmt / 100)}
              </div>
          </div>
        }

        {
          cartPage === "shipping" &&
          <div className={styles['delivery-fee']}>
            <div className={styles['fee-title']}>Total</div>
              <div className={styles['fee-value']}>
                {currentCurrency === 'NGN' ?
                  <span dangerouslySetInnerHTML={{ __html: "&#8358;" }}></span>
                  : '$'
                } {formatMoney((calcCartTotal(cart, currentCurrency, activeAttributes) + parseInt(deliveryFee) + parseInt(taxAmount) - discountAmt) / 100)}
              </div>
          </div>
        }

        <div className={styles['summary-bottom']}>
          <button
            className={checkoutButtonClasses}
            onClick={handleChangeCartPage}
          >
            {cartPage === "order" ? "Make Payment" : "Checkout"}
          </button>
        </div>
      </div>
    </>
  )
}

export default CartFooter;